<div class="overflow-hidden" class="{{type+'-spinner'}}">
  <mat-spinner color="accent" class="mx-auto"></mat-spinner>
</div>
